import React from 'react';

import { Card } from '@iris/react-components/Card';
import { AndroidIcon } from '@iris/react-icons/AndroidIcon';
import { AppleIcon } from '@iris/react-icons/AppleIcon';
import { ArrowRoadIcon } from '@iris/react-icons/ArrowRoadIcon';
import { AutoHighBeamHeadlightsIcon } from '@iris/react-icons/AutoHighBeamHeadlightsIcon';
import { BackupCameraIcon } from '@iris/react-icons/BackupCameraIcon';
import { BlindSpotMonitorIcon } from '@iris/react-icons/BlindSpotMonitorIcon';
import { BluetoothIcon } from '@iris/react-icons/BluetoothIcon';
import { BrakesIcon } from '@iris/react-icons/BrakesIcon';
import { CaptainChairIcon } from '@iris/react-icons/CaptainChairIcon';
import { CarFrontIcon } from '@iris/react-icons/CarFrontIcon';
import { CarLanesIcon } from '@iris/react-icons/CarLanesIcon';
import { CarLeavingLaneIcon } from '@iris/react-icons/CarLeavingLaneIcon';
import { CarLockIcon } from '@iris/react-icons/CarLockIcon';
import { CarParkingIcon } from '@iris/react-icons/CarParkingIcon';
import { CooledSeatsIcon } from '@iris/react-icons/CooledSeatsIcon';
import { CrossTrafficAlertIcon } from '@iris/react-icons/CrossTrafficAlertIcon';
import { DisabilityEquippedIcon } from '@iris/react-icons/DisabilityEquippedIcon';
import { DualRearWheelsIcon } from '@iris/react-icons/DualRearWheelsIcon';
import { DvdPlayerIcon } from '@iris/react-icons/DvdPlayerIcon';
import { FifthRowSeatsIcon } from '@iris/react-icons/FifthRowSeatsIcon';
import { FogLightsIcon } from '@iris/react-icons/FogLightsIcon';
import { FourthRowSeatsIcon } from '@iris/react-icons/FourthRowSeatsIcon';
import { FrontViewCameraIcon } from '@iris/react-icons/FrontViewCameraIcon';
import { GaugeArrowLeftIcon } from '@iris/react-icons/GaugeArrowLeftIcon';
import { GaugeArrowRightIcon } from '@iris/react-icons/GaugeArrowRightIcon';
import { GearIcon } from '@iris/react-icons/GearIcon';
import { HeatedMirrorsIcon } from '@iris/react-icons/HeatedMirrorsIcon';
import { HeatedSeatsIcon } from '@iris/react-icons/HeatedSeatsIcon';
import { HeatedSteeringWheelIcon } from '@iris/react-icons/HeatedSteeringWheelIcon';
import { KeyFobStartIcon } from '@iris/react-icons/KeyFobStartIcon';
import { KeyFobUnlockIcon } from '@iris/react-icons/KeyFobUnlockIcon';
import { LedHeadlightsIcon } from '@iris/react-icons/LedHeadlightsIcon';
import { MassageSeatsIcon } from '@iris/react-icons/MassageSeatsIcon';
import { MoonRoadIcon } from '@iris/react-icons/MoonRoadIcon';
import { MusicNotePhoneIcon } from '@iris/react-icons/MusicNotePhoneIcon';
import { MusicNoteRadiatingIcon } from '@iris/react-icons/MusicNoteRadiatingIcon';
import { ParkingSensorsIcon } from '@iris/react-icons/ParkingSensorsIcon';
import { PowerButtonIcon } from '@iris/react-icons/PowerButtonIcon';
import { PowerClosingDoorIcon } from '@iris/react-icons/PowerClosingDoorIcon';
import { PowerOutletIcon } from '@iris/react-icons/PowerOutletIcon';
import { PremiumSeatsIcon } from '@iris/react-icons/PremiumSeatsIcon';
import { PremiumSteeringWheelIcon } from '@iris/react-icons/PremiumSteeringWheelIcon';
import { PremiumWheelsIcon } from '@iris/react-icons/PremiumWheelsIcon';
import { RearHatchSensorIcon } from '@iris/react-icons/RearHatchSensorIcon';
import { RoofRackIcon } from '@iris/react-icons/RoofRackIcon';
import { SatelliteDishIcon } from '@iris/react-icons/SatelliteDishIcon';
import { SignalIcon } from '@iris/react-icons/SignalIcon';
import { SnowflakeIcon } from '@iris/react-icons/SnowflakeIcon';
import { SnowflakeSunIcon } from '@iris/react-icons/SnowflakeSunIcon';
import { SpoilerIcon } from '@iris/react-icons/SpoilerIcon';
import { StarRadiatingIcon } from '@iris/react-icons/StarRadiatingIcon';
import { SteeringWheelControlsIcon } from '@iris/react-icons/SteeringWheelControlsIcon';
import { SteeringWheelIcon } from '@iris/react-icons/SteeringWheelIcon';
import { SteeringWheelRoadIcon } from '@iris/react-icons/SteeringWheelRoadIcon';
import { SunIcon } from '@iris/react-icons/SunIcon';
import { SunroofIcon } from '@iris/react-icons/SunroofIcon';
import { TeenDriverTechIcon } from '@iris/react-icons/TeenDriverTechIcon';
import { ThirdRowSeatsIcon } from '@iris/react-icons/ThirdRowSeatsIcon';
import { ThreeSixtyDegreeCameraIcon } from '@iris/react-icons/ThreeSixtyDegreeCameraIcon';
import { TowHitchIcon } from '@iris/react-icons/TowHitchIcon';
import { TrafficArrowIcon } from '@iris/react-icons/TrafficArrowIcon';
import { TrafficConeIcon } from '@iris/react-icons/TrafficConeIcon';
import { TrafficSignIcon } from '@iris/react-icons/TrafficSignIcon';
import { TruckBedCoverIcon } from '@iris/react-icons/TruckBedCoverIcon';
import { TruckBedLinerIcon } from '@iris/react-icons/TruckBedLinerIcon';
import { UsbPortsIcon } from '@iris/react-icons/UsbPortsIcon';
import { WifiHotspotIcon } from '@iris/react-icons/WifiHotspotIcon';
import { WindshieldWiperRainIcon } from '@iris/react-icons/WindshieldWiperRainIcon';
import clsx from 'clsx';
import _get from 'lodash/get';

import { useDevice } from '@bonnet/core/device';

import { useFeatures } from '@atc/features';

import {
    Carousel,
    Heading,
    Section,
    SubHeading,
    Text,
} from 'reaxl';

import VehicleFeatureHighlights from './VehicleFeatureHighlights';
import VehicleFeaturesSheet from './VehicleFeaturesSheet';

function getCarouselHeaderIcon(tabName) {
    switch (tabName) {
        case 'highlights':
            return <StarRadiatingIcon />;
        case 'safety':
            return <TrafficConeIcon />;
        case 'technology':
            return <SignalIcon />;
        case 'interior':
            return <SteeringWheelIcon />;
        case 'exterior':
            return <CarFrontIcon />;
        case 'mechanical':
            return <GearIcon />;
        default:
            return null;
    }
}

function getFeaturesIcon(feature) {

    switch (feature) {
        case 'Disability Equipped':
            return <DisabilityEquippedIcon />;
        case '360-Degree Camera':
            return <ThreeSixtyDegreeCameraIcon />;
        case 'Front View Camera':
            return <FrontViewCameraIcon />;
        case 'Backup Camera':
            return <BackupCameraIcon />;
        case 'Blind Spot Monitor':
            return <BlindSpotMonitorIcon />;
        case 'Lane Departure Warning':
            return <CarLeavingLaneIcon />;
        case 'Cross Traffic Alert':
            return <CrossTrafficAlertIcon />;
        case 'Adaptive Cruise Control':
            return <GaugeArrowRightIcon />;
        case 'Automatic Parking':
            return <CarParkingIcon />;
        case 'Apple CarPlay':
            return <AppleIcon />;
        case 'Android Auto':
            return <AndroidIcon />;
        case 'Bluetooth, Hands-Free':
            return <BluetoothIcon />;
        case 'Navigation':
            return <TrafficArrowIcon />;
        case 'Cooled Seats':
            return <CooledSeatsIcon />;
        case 'Heated Seats':
            return <HeatedSeatsIcon />;
        case 'Leather Seats':
            return <PremiumSeatsIcon />;
        case 'Remote Engine Start':
            return <KeyFobStartIcon />;
        case 'Keyless Entry':
            return <KeyFobUnlockIcon />;
        case 'Keyless Start':
            return <PowerButtonIcon />;
        case 'Multi-zone Climate Control':
            return <SnowflakeSunIcon />;
        case 'Heated Steering Wheel':
            return <HeatedSteeringWheelIcon />;
        case 'WiFi Hotspot':
            return <WifiHotspotIcon />;
        case 'Panoramic Roof':
            return <SunIcon />;
        case 'Sunroof':
        case 'Moonroof':
            return <SunroofIcon />;
        case 'Hands Free Lift Gate':
            return <RearHatchSensorIcon />;
        case '2nd Row Captain Chairs':
            return <CaptainChairIcon />;
        case 'Premium Audio':
            return <MusicNoteRadiatingIcon />;
        case 'LED Headlights':
            return <LedHeadlightsIcon />;
        case 'USB Ports':
            return <UsbPortsIcon />;
        case 'Portable Audio Connection':
            return <MusicNotePhoneIcon />;
        case '3rd Row Seats':
            return <ThirdRowSeatsIcon />;
        case 'Satellite Radio':
            return <SatelliteDishIcon />;
        case 'Brake Assist':
            return <BrakesIcon />;
        case 'Lane Keep Assist':
            return <CarLanesIcon />;
        case 'Night Vision':
            return <MoonRoadIcon />;
        case 'Traffic Sign Recognition':
            return <TrafficSignIcon />;
        case 'Heated Mirrors':
            return <HeatedMirrorsIcon />;
        case 'Auto High Beam Headlights':
            return <AutoHighBeamHeadlightsIcon />;
        case 'Fog Lights':
            return <FogLightsIcon />;
        case 'Parking Sensors':
            return <ParkingSensorsIcon />;
        case 'Steering Wheel Controls':
            return <SteeringWheelControlsIcon />;
        case 'Security System':
            return <CarLockIcon />;
        case 'Head-Up Display':
            return <ArrowRoadIcon />;
        case 'DVD Player':
            return <DvdPlayerIcon />;
        case 'Rear Climate Control':
            return <SnowflakeIcon />;
        case 'Trailer Hitch':
            return <TowHitchIcon />;
        case 'Roof Rack':
            return <RoofRackIcon />;
        case 'Truck Bed Liner':
            return <TruckBedLinerIcon />;
        case 'Truck Bed Cover':
            return <TruckBedCoverIcon />;
        case 'Power Closing Door':
            return <PowerClosingDoorIcon />;
        case 'Dual Rear Wheels':
            return <DualRearWheelsIcon />;
        case '115v Power Outlet':
            return <PowerOutletIcon />;
        case 'Seat Massage System':
            return <MassageSeatsIcon />;
        case 'Leather Steering Wheel':
            return <PremiumSteeringWheelIcon />;
        case '4th Row Seat':
            return <FourthRowSeatsIcon />;
        case '5th Row Seat':
            return <FifthRowSeatsIcon />;
        case 'Spoiler':
            return <SpoilerIcon />;
        case 'Autopilot':
            return <SteeringWheelRoadIcon />;
        case 'Cruise Control':
            return <GaugeArrowLeftIcon />;
        case 'Premium Wheels':
            return <PremiumWheelsIcon />;
        case 'Rain Sensing Wipers':
            return <WindshieldWiperRainIcon />;
        case 'Teen Driver Tech':
            return <TeenDriverTechIcon />;
        default:
            return null;
    }
}

/**
 * A carousel that holds cards containing the vehicle's features.
 *
 * @component
 * @param {Object} props
 * @param {Object} [props.features] - Object containing the non-ranked features used in the modal
 * @param {Object} [props.packages] - Object containing the non-ranked package features used only in the modal
 * @param {Object} [props.rankedFeatures] - Object containing the ranked features and the list items features
 * @param {string} props.sectionHeader - The header text to display above the carousel
 * @param {string} props.vehicleTitle - The title of the vehicle (will be cleaned of "New"/"Used" prefixes)
 * @returns {JSX.Element} A carousel full of vehicle features cards
 *
 */

export default function VehicleFeaturesCarousel(
    {
        features = {},
        packages = {},
        rankedFeatures = {},
        sectionHeader,
        vehicleTitle,
    }
) {
    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);

    const {
        vehicle_highlight_specs: [enableVehicleHighlightSpecs],
    } = useFeatures([
        'vehicle_highlight_specs',
    ]);

    const vehicleFeaturesCards = [...Object.keys(rankedFeatures)].map((featureHeader) => (
        <Card
            className="iris:mr-4 iris:overflow-hidden"
            key={featureHeader + 'VehicleFeatureCard'}
        >
            <Card.Content>
                <div
                    className="margin-left-auto margin-right-auto features-card-icon"
                >
                    {getCarouselHeaderIcon(featureHeader)}
                </div>

                <SubHeading
                    level={3}
                    className="margin-top-2 text-blue-darkest text-center"
                >
                    {featureHeader.charAt(0).toUpperCase() + String(featureHeader).slice(1)}
                </SubHeading>

                <Text
                    size={300}
                    className="padding-bottom-2"
                >
                    {rankedFeatures?.[featureHeader].slice(0, 6).map((feature, index) => (
                        <div
                            key={feature + 'FeatureCardItem'}
                            className={clsx(
                                'text-align-center',
                                'display-flex',
                                'align-items-center',
                                {
                                    'margin-top-5': index === 0,
                                    'margin-top-4': index !== 0,
                                }
                            )}
                        >

                            <span
                                className="margin-right-3 features-card-icon-primary"
                            >
                                {getFeaturesIcon(feature)}
                            </span>
                            {feature}
                        </div>
                    ))}
                </Text>
            </Card.Content>
        </Card>
    ));

    return (
        <Section
            alignment="left"
            className="padding-bottom-5"
        >
            {sectionHeader && (
                <Heading
                    className={clsx(
                        'padding-bottom-2',
                        'margin-bottom-3',
                        {
                            'padding-top-5': !isXs,
                        }
                    )}
                    level={3}
                >
                    {sectionHeader}
                </Heading>
            )}
            {enableVehicleHighlightSpecs && <VehicleFeatureHighlights />}
            <Carousel
                cellWidth="300px"
                initialIndex={0}
                fullWidth
                fullHeight
                fullWidthScroll
                scrollItemsCount={1}
            >
                {
                    ...vehicleFeaturesCards
                }
            </Carousel>

            {(!!packages?.length || (features && !!Object.keys(features).length)) && (
                <div className="display-flex justify-content-center margin-top-5 iris:text-[var(--base-color-primary-600)] iris:font-bold">
                    {/* Sheet Component Trigger inherits styles so setting font color and weight in parent div */}
                    <VehicleFeaturesSheet
                        packages={packages}
                        features={features}
                        vehicleTitle={vehicleTitle}
                    />
                </div>
            )}
        </Section>
    );
}
